import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { createUser } from "../../../api/users";
import AddUserForm from "../../../components/Users/AddUserForm";
import { useErrorHandler } from "../../../hooks/Error/useErrorHandler";
import { setLoading } from "../../../store/UI";
import { CreateUserForm } from "../../../types/forms/admin/user";
import { Role } from "../../../types/interfaces/account";
import { PrivateSettings } from "../../../types/interfaces/app";
import { StoreInterfaces } from "../../../types/store";

const AddUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleError = useErrorHandler();
  const [availableRoles, setAvailableRoles] = React.useState<Role[]>([]);

  const [searchParams] = useSearchParams();
  const accountIdFromUrl = searchParams.get("accountId");

  const privateSettings: PrivateSettings | undefined = useSelector(
    (state: StoreInterfaces) => state.app.privateSettings,
    shallowEqual,
  );

  useEffect(() => {
    if (privateSettings?.roles) {
      setAvailableRoles(privateSettings.roles);
    }
  }, [privateSettings]);

  const handleSaveAction = async (
    values: CreateUserForm,
    selectedAccountId?: number,
  ) => {
    try {
      dispatch(setLoading(true));

      const finalAccountId =
        selectedAccountId ?? Number.parseInt(accountIdFromUrl!);

      const response = await createUser(finalAccountId, values);
      navigate(`/admin/users/${response.accountId}/${response.id}`, { replace: true });
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div>
      <AddUserForm
        onSubmit={handleSaveAction}
        accountId={
          accountIdFromUrl ? Number.parseInt(accountIdFromUrl) : undefined
        }
        availableRoles={availableRoles}
      />
    </div>
  );
};

export default AddUser;
